import { render, staticRenderFns } from "./AdministrationTab.vue?vue&type=template&id=091350aa&"
import script from "./AdministrationTab.vue?vue&type=script&lang=ts&"
export * from "./AdministrationTab.vue?vue&type=script&lang=ts&"
import style0 from "./AdministrationTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports